export default import.meta.ROLLUP_FILE_URL_dL0rrE$LBRtTd31OSerTHg